// © Microsoft Corporation. All rights reserved.
import { __awaiter } from "tslib";
import { BlankCacheBustingUrl, CbidUncaughtErrors, InvalidCbidResponse } from "../AppErrors";
import { environment, logger } from "../wwCommon";
/**
 * Get cache busting identifier from live CMS document
 * @returns number - cache busting identifier. Typical value would be 1, 2 etc.
 */
export function getLiveCacheBustingIdentifier() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { cacheBustingConfigUrl } = environment;
            if (!cacheBustingConfigUrl) {
                logger.error(Object.assign(Object.assign({}, BlankCacheBustingUrl), { message: "WebWorker.cbid environment.cacheBustingConfigUrl is not set." }));
                return undefined;
            }
            const response = yield downloadFile(cacheBustingConfigUrl.toString());
            const liveCbid = parseInt(response);
            // We are checking response length > 1 and liveCbid > 9 temporarily.
            // Since we are seeing CBID greater than actual value in prod.
            // This logger statement that sends app error in web worker will help us diagnose the issue.
            // Bug 26748636: Remove app error logging temporary code in ConfigCacheBustHelper.ts
            if (!response
                || response.length !== 1
                || !liveCbid
                || isNaN(liveCbid)
                || liveCbid > 9) {
                logger.error(Object.assign(Object.assign({}, InvalidCbidResponse), { message: "WebWorker.cbid response length !== 1", pb: Object.assign(Object.assign({}, InvalidCbidResponse.pb), { customMessage: `LiveCbid: ${liveCbid || ""}. Url: ${cacheBustingConfigUrl.toString()}. Response: ${response || ""}.` }) }));
                return undefined;
            }
            return liveCbid;
        }
        catch (error) {
            logger.error(Object.assign(Object.assign({}, CbidUncaughtErrors), { message: "WebWorker.cbid network error. Refer customMessage", pb: Object.assign(Object.assign({}, CbidUncaughtErrors.pb), { customMessage: `WebWorker.cbid: ${error}` }) }));
            return undefined;
        }
    });
}
/**
 * downloads file from given the url
 * @private
 * @param {string} url - url of the document
 * @return Promise<string> returns response from cache busting document
 */
function downloadFile(url) {
    return __awaiter(this, void 0, void 0, function* () {
        return fetch(url)
            .then(response => {
            if (!response.ok) {
                throw new Error(`Error downloading file: ${url} with status code: ${response.statusText}.`);
            }
            return response.text();
        });
    });
}
//# sourceMappingURL=ConfigCacheBustHelper.js.map